/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcChatRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M8.75 11.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M12 10a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5.75 1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" />
      <path
        fillRule="evenodd"
        d="M12 1.1c-5.918 0-10.9 4.286-10.9 9.789 0 2.033.69 3.914 1.856 5.468L2.018 21.3a.9.9 0 0 0 1.28.976l4.67-2.29c1.249.447 2.61.692 4.032.692 5.917 0 10.9-4.286 10.9-9.79C22.9 5.387 17.917 1.1 12 1.1m-9.1 9.789C2.9 6.573 6.87 2.9 12 2.9s9.1 3.673 9.1 7.989-3.972 7.989-9.1 7.989c-1.34 0-2.607-.254-3.747-.707a.9.9 0 0 0-.729.028l-3.402 1.668.679-3.576a.9.9 0 0 0-.189-.739C3.528 14.232 2.9 12.621 2.9 10.89"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcChatRegular;
